/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useApolloClient, useQuery, useLazyQuery } from "react-apollo";
import PropTypes from "prop-types";
import gql from "graphql-tag";
import moment from "moment";
import { OrdersTable } from "../../../../components/Orders";
import {
  UPDATE_ORDER_MUTATION,
  ALL_ORDERS_VIEW_BY_PAGE_QUERY
} from "../../../../graphql/Orders/Orders.graphql";
import Loading from "../../../../components/Loading";
import { ourToast as toast, runPromisesInSeries } from "../../../../utils";
import { ROUTE_VERIFIED_COLUMNS } from "../columns";

const ALL_SYSTEM_CODES_QUERY = gql`
  query SystemCodes($where: SystemCodeWhereInput!) {
    SystemCodes(where: $where) {
      RecId
      Type
      Category
      CodeName
      CodeId
      CodeDescription
    }
  }
`;

const BillingVerified = ({ date }) => {
  const SystemCodes = useQuery(ALL_SYSTEM_CODES_QUERY, {
    variables: {
      where: {
        Category_in: ["Order"],
        CodeName_in: ["OrderStatus"],
        CodeId_in: ["RV", "BV"]
      }
    }
  });
  const client = useApolloClient();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [States, setStates] = useState(null);
  const [selectedFlatRows, setSelectedFlatRows] = useState([]);

  const [getOrdersData, { data: OrdersData }] = useLazyQuery(
    ALL_ORDERS_VIEW_BY_PAGE_QUERY
  );

  useEffect(() => {
    const bvStatus = States?.BillingVerified?.RecId;
    if (bvStatus && date) {
      getOrdersData({
        variables: {
          where: {
            RequestedDeliveryDate_lt: moment(date)
              .endOf("day")
              .toDate(),
            StatusRecIdRef: bvStatus
          }
        }
      });
    }
  }, [States, date, getOrdersData]);

  useEffect(() => {
    if (SystemCodes?.data?.SystemCodes?.length > 0 && !States) {
      setStates({
        RouteVerified: SystemCodes.data.SystemCodes.find(
          s => s.CodeId === "RV"
        ),
        BillingVerified: SystemCodes.data.SystemCodes.find(
          s => s.CodeId === "BV"
        )
      });
    }
  }, [States, SystemCodes, SystemCodes.data]);

  const handleResetToRouteVerified = async selectedData => {
    try {
      if (!selectedData.length) {
        throw Error("Please select some orders to be reset");
      }
      setLoading(true);

      await runPromisesInSeries(
        selectedData.map((RecId, index) => {
          const obj = {
            mutation: UPDATE_ORDER_MUTATION,
            variables: {
              data: {
                StatusRecIdRef: States.RouteVerified.RecId
              },
              where: {
                RecId
              }
            }
          };
          if (index === selectedData.length - 1) {
            obj.refetchQueries = ["ALL_ORDERS_VIEW_QUERY"];
          }
          return () => client.mutate(obj);
        })
      );

      setLoading(false);
      toast.success("Orders reseted successfully");
    } catch (err) {
      toast.error("Error reseting Orders.");
    }
  };

  if (loading || SystemCodes?.loading || !States?.BillingVerified) {
    return <Loading />;
  }

  const totalBillingVerifiedOrders =
    OrdersData?.VW_OrdersByPage?.Payload?.length || 0;
  return (
    <OrdersTable
      callToAction1={handleResetToRouteVerified}
      columns={ROUTE_VERIFIED_COLUMNS}
      initialSortBy={[
        {
          id: "ScheduledDeliveryDate",
          desc: false
        },
        { id: "OrderNumber", desc: false }
      ]}
      selectedFlatRows={selectedFlatRows}
      setSelectedFlatRows={setSelectedFlatRows}
      title={`Billing Verified (${totalBillingVerifiedOrders})`}
      where={{
        ScheduledDeliveryDate_lt: moment(date)
          .endOf("day")
          .toDate(),
        StatusRecIdRef: States?.BillingVerified?.RecId
      }}
      onCellClick={cell => {
        if (cell.column.id !== "selection") {
          history.push(`/dispatch/orders/${cell.row.original.RecId}/BOL-ELD`);
        }
      }}
    />
  );
};
BillingVerified.propTypes = {
  date: PropTypes.string
};
export default BillingVerified;
